// This file is generated by scripts/build-locals.ts
import en from './en.json'
import zh from './zh.json'

export default {
    'en': en,
    'zh': zh,
};